import { getCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/selectors';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { EDITOR_DRAFT_EXPIRATION_DELTA } from './constants';
// Gets editor drafts json data from local storage and parses it
export function getEditorDraftsState(state) {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return JSON.parse(getCompliantLocalStorageItem(state, CompliantLocalStorageKeys.EDITOR_DRAFTS) || '{}');
}
// Gets editor draft data for a specific editor key.
// If the draft is expired it returns undefined, otherwise it returns the initial content to be loaded by editor.
export function getEditorDraft(state, editorKey) {
    const allDrafts = getEditorDraftsState(state);
    const draftState = allDrafts && allDrafts[editorKey];
    const minUpdatedDate = Date.now() - EDITOR_DRAFT_EXPIRATION_DELTA;
    if (!draftState || draftState.updatedAt < minUpdatedDate) {
        return undefined;
    }
    return draftState.editorState;
}

//# sourceMappingURL=selectors.js.map